import { useCallback } from 'react';
import { useSetAtom } from 'jotai';

import { referralInviteModalAtom, ReferralInviteSource } from './referral-modal.atoms';

// All referral CTAs open the invite through this hook, so none of them needs to know how the invite is shown.
export const useOpenReferralInvite = () => {
  const setModal = useSetAtom(referralInviteModalAtom);

  return useCallback(
    (source: ReferralInviteSource) => {
      setModal({ isOpen: true, source });
    },
    [setModal]
  );
};
